import React, { Component } from 'react';
import { serverIp, firebaseAuth, toCurrency, pythonApiIp, logComponentLoad, zippcoServerIp } from '../../../../config/constants.js'
import { Form, Segment, Button, Table } from 'semantic-ui-react';
import * as UiConsts from '../../../../config/UiConstants';
import axios from 'axios';
import { SingleDatePicker } from 'react-dates';
//import { getPrintValues, getDesigners, checkAdminEmail } from '../../dashBoard/newDashboard/algoliaDashboard/AlgoliaMiscUtils';
import { getPrintValues, checkAdminEmail } from '../algoliaDashboard/AlgoliaMiscUtils';
import Select from 'react-select';
import PhoneMoneyLogTransactions from './PhoneMoneyLogTransactions.js';

class PhoneMoneyLog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            amount: 0,
            phoneBalance: 0,
            newBalance: null,
            reason: '',
            dateString: '',
            fromWhere: '',
            dateDone: '',
            phoneMoneyLog: [],

            options: [],

            action: '',
            actionOptions: [
                {
                    "category": "action",
                    "label": "sent",
                    "value": "sent",
                    "key": "sent"
                },
                {
                    "category": "action",
                    "label": "received",
                    "value": "received",
                    "key": "received"
                }
            ],
            sentTo: '',
            sentToOptions: [],

            //  boo = 
            //  {
            //     "grouping": "phoneMoneyLog",
            //     "order": 1,
            //     "valid": true,
            //     "category": "phoneMoneyLogOptions",
            //     "label": "Sharrif Mtn",
            //     "value": "sharrif_mtn",
            //     "key": "sharrif_mtn"
            // }
            // ,

            sentFrom: '',
            sentFromOptions: [],

            receivedFrom: '',
            receivedFromOptions: [ ]
        }
    }


    componentDidMount() {
        console.log("entx8 +++++ componentDidMount - ");

        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("elx1 +++++++++:removeListener");


            if (user) {


                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)
                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })
            }


        })
    }


    setAdminResult = (returnObject) => {
        // console.log("++++++ addx294 setAdminResult");
        // console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));

        logComponentLoad(returnObject, "PhoneMoneyLogs");

        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })

        this.getTransactions();
        getPrintValues("phoneMoneyLog", this.loadOptions);
    }

    loadOptions = (options) => {
        console.log("docx1 ++++++ loadOptions ");
       // console.log("docx12 docs:" + JSON.stringify(options, null, 3));
        this.setState({ options: options })

        let sentToOptions = [];
        let sentFromOptions = [];
        let receivedFromOptions = [];

        //CREATE SENT TO
        options.forEach(val => {
            console.log('docx12 adding item:' + val.value);

            // "category": "sentTo",
            // "label": "Ivan Stanbic",
            // "value": "ivan_stanbic",
            // "key": "ivan_stanbic"

            let sentOption = {};
            sentOption.category = "sentTo";
            sentOption.label = val.label;
            sentOption.value = val.value;
            sentOption.key = val.key;
            sentToOptions.push(sentOption)
            console.log("sentOptions:" + JSON.stringify(sentToOptions, null, 3))

            let sentFromOption = {};
            sentFromOption.category = "sentFrom";
            sentFromOption.label = val.label;
            sentFromOption.value = val.value;
            sentFromOption.key = val.key;
            sentFromOptions.push(sentFromOption)
            console.log("sentFromOptions:" + JSON.stringify(sentFromOptions, null, 3))

            let receivedFromOption = {};
            receivedFromOption.category = "receivedFrom";
            receivedFromOption.label = val.label;
            receivedFromOption.value = val.value;
            receivedFromOption.key = val.key;
            receivedFromOptions.push(receivedFromOption)
           //console.log("receivedFromOptions:" + JSON.stringify(receivedFromOptions, null, 3))


            this.setState({
                sentToOptions: sentToOptions,
                sentFromOptions: sentFromOptions,
                receivedFromOptions: receivedFromOptions
            })



            //tempArray.push(val.option_name)
        });
    }

    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }

    // ##########################::  sendPhoneMoneyLog :##########################:
    sendPhoneMoneyLog = () => {
        console.log("entx1 +++++ sendPhoneMoneyLog - ");

        //if (this.state.depositAmount.length < 4) {
        if (this.state.action == '') {
            alert("please select an action");
        } else if (this.state.action == 'sent' && this.state.sentTo == '') {
            alert("please select sent to");
        } else if (this.state.action == 'sent' && this.state.sentFrom == '') {
            alert("please select sentFrom");
        } else if (this.state.action == 'received' && this.state.receivedFrom == '') {
            alert("please select receivedFrom");
        } else if (this.state.amount == 0) {
            alert("please enter an amount");
        } else if (this.state.description == '') {
            alert("please enter an description");
        } else if (this.state.dateDone == '') {
            alert("please enter dateDone");
        }
        else {

            this.setState({ loading: true });
            console.log("entx122 all is well sending sendPhoneMoneyLog");

           // https://zippcosupply.com:8181/bidding/resources/submit/getAllBids

            // SEND CHECK TO SERVER
            axios.post(serverIp + 'salesApp/enterPhoneMoneyLog', {
                apiKey: "entx122",
                phone: "bizphone",
                dateDelivered: this.state.dateDone,
                amountDep: this.state.amount,
                description: this.state.description,
                mobileMoneyMessage: this.state.mobileMoneyMessage,
                sentTo: this.state.sentTo,
                phoneBalance: this.state.phoneBalance,
                action: this.state.action,
                sentFrom: this.state.sentFrom,
                receivedFrom: this.state.receivedFrom,
                enteredBy: this.state.user.email
            })
                .then((response) => {

                    if (response.data.result) {

                        this.setState({ loading: false });
                        this.getTransactions();
                        this.resetFields();

                        alert("Success:" + response.data.message);

                        // CHECK ORDER NUMBER
                    } else if (!response.data.result) {
                        alert("Error:" + response.data.message);
                        this.setState({ loading: false });
                    }

                    this.clearFields();

                })
                .catch((error) => {
                    console.log(error);
                    //this.setState({ loading: false })
                    this.clearFields();
                });

        }
    }

    getTransactions = () => {
        console.log("cpx1 ======getTransactions");

        this.setState({ loading: true })

//https://zippcosupply.com:8181/bidding/resources/submit/getAllBids
//axios.post(serverIp + 'salesApp/getAllPhoneMoneyLog', {
        axios.post(serverIp + 'salesApp/getAllPhoneMoneyLog', {
       // axios.post(zippcoServerIp, {
            apiKey: "getAllPhoneMoneyLog",
            enteredBy: this.state.user.email
        })
            .then((response) => {
                this.setState({ loading: false })
                console.log(response.data);

                if (response.data.result) {
                    console.log("true.. getAllPhoneMoneyLog");

                    this.setState({ phoneMoneyLog: response.data.phoneMoneyLog });

                } else {
                    console.log("FAILED");
                    alert("FAILED TO get transactions:");
                }
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    loading: false
                })
            });
    }

    resetFields = () => {
        this.setState({
            amount: '',
            description: '',
            mobileMoneyMessage: '',
            sentTo: '',
            phoneBalance: '',
            action: ''
        })
    }

    dateSelectOnChange = (date) => {
        console.log("+++++++:dateSelectOnChange");
        console.log("date sent:" + date)
        console.log("dateString:" + date.format('dddd MMMM Do'));
        console.log("dateString:" + date.format('YYYY-MM-DD'));
        this.setState({
            selectedDate: date.valueOf(),
            dateString: date.format('dddd MMMM Do'),
            dateDone: date.format('YYYY-MM-DD')
        })

        console.log(date.valueOf());
    }

    clearFields = () => {

        this.setState({
            loading: false,
            depositAmount: 0,
            deductAmount: 0,
            reason: '',
            selectedDate: '',
            dateString: '',
            fromWhere: '',
            receivedFrom: ''
        })
    }

    handleDropDownChanges = (value) => {
        console.log("docx19 handleDropDownChanges");
        console.log('docx191 You\'ve sss:', value);
        console.log("docx192 category alone:" + value.category);
        console.log('docx193 You\'ve selected:', value.value + " " + value.category);

        let newState = {};
        newState[value.category] = value.value;
        console.log("newState 1:" + JSON.stringify(newState, null, 3));

        //this.setState(newState);
        this.setState(newState);
    }


    render() {

        const sentToDropdown = this.state.action === 'sent'
            ?
            <div>
                <label> SENT TO </label>
                <Select
                    name="form-field-name"
                    value={this.state.sentTo}
                    options={this.state.sentToOptions}
                    onChange={this.handleDropDownChanges}
                    searchable={false}
                    clearable={false}
                />
            </div>
            : ''

        const sentFromDropdown = this.state.action === 'sent'
            ?
            <div>
                <br />
                <label> SENT FROM </label>
                <Select
                    name="form-field-name"
                    value={this.state.sentFrom}
                    options={this.state.sentFromOptions}
                    onChange={this.handleDropDownChanges}
                    searchable={false}
                    clearable={false}
                />
            </div>
            : ''

        const receivedFromDropdown = this.state.action === 'received'
            ?

            <div>
                <br />
                <label> Received FROM </label>
                <Select
                    name="form-field-name"
                    value={this.state.receivedFrom}
                    options={this.state.receivedFromOptions}
                    onChange={this.handleDropDownChanges}
                    searchable={false}
                    clearable={false}
                />
            </div>
            : ''

        const cardList = this.state.phoneMoneyLog.length > 0
            ? this.state.phoneMoneyLog.map((item) =>
                <PhoneMoneyLogTransactions item={item} user={this.state.user} getTransactions={this.getTransactions} />
            )
            : ''

        // const logTable = this.state.phoneMoneyLog.length > 0
        //     ? <Table celled>
        //         <Table.Header>
        //             <Table.Row>
        //                 <Table.HeaderCell>id</Table.HeaderCell>
        //                 <Table.HeaderCell>Date</Table.HeaderCell>
        //                 <Table.HeaderCell>Amount</Table.HeaderCell>
        //                 <Table.HeaderCell>Action</Table.HeaderCell>
        //                 <Table.HeaderCell>Sent To</Table.HeaderCell>
        //                 <Table.HeaderCell>Description</Table.HeaderCell>
        //                 <Table.HeaderCell>Balance</Table.HeaderCell>
        //             </Table.Row>
        //         </Table.Header>

        //         <Table.Body>
        //             {tableRow}
        //         </Table.Body>

        //     </Table>
        //     : ''

        const wholeUI = this.state.user && this.state.user.email && this.state.algoliaUser != null && this.state.algoliaUser.perms.includes("sales")
            ? <div>


                <Segment stacked>
                    <Form size='large' onSubmit={this.sendPhoneMoneyLog}>
                        <SingleDatePicker
                            date={this.state.date} // momentPropTypes.momentObj or null
                            //onDateChange={date => this.setState({ date })} // PropTypes.func.isRequired
                            onDateChange={date => this.dateSelectOnChange(date)} // PropTypes.func.isRequired
                            focused={this.state.focused} // PropTypes.bool
                            onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
                            isOutsideRange={() => false}
                        />
                        <h3>{this.state.dateString}</h3>

                        <label> ACTION </label>
                        <Select
                            name="form-field-name"
                            value={this.state.action}
                            options={this.state.actionOptions}
                            onChange={this.handleDropDownChanges}
                            searchable={false}
                            clearable={false}
                        />

                        {sentToDropdown}

                        {sentFromDropdown}

                        {receivedFromDropdown}

                        {/* amountDep*/}
                        <Form.Field>
                            <label> Amount</label>
                            <label>{toCurrency(this.state.amount)}</label>
                            <Form.Input
                                fluid
                                name={'amount'}
                                value={this.state.amount}
                                icon='add user'
                                iconPosition='left'
                                placeholder='amount'
                                // onFocus={props.amp_logFieldClick}
                                onChange={this.handleTextInputChange}
                                type='number' />
                        </Form.Field>

                        {/* depositAmount*/}
                        <Form.Field>
                            <label>Description</label>
                            <Form.Input
                                fluid
                                name={'description'}
                                value={this.state.description}
                                icon='add user'
                                iconPosition='left'
                                placeholder='description'
                                onChange={this.handleTextInputChange}
                                type='text' />
                        </Form.Field>

                        {/* depositAmount*/}
                        <Form.Field>
                            <label>mobileMoneyMessage (if applicable)</label>
                            <Form.Input
                                fluid
                                name={'mobileMoneyMessage'}
                                value={this.state.mobileMoneyMessage}
                                icon='add user'
                                iconPosition='left'
                                placeholder='mobileMoneyMessage (if there is one)'
                                onChange={this.handleTextInputChange}
                                type='text' />
                        </Form.Field>

                        {/* depositAmount*/}
                        <Form.Field>
                            <label>Phone Balance</label>
                            <Form.Input
                                fluid
                                name={'phoneBalance'}
                                value={this.state.phoneBalance}
                                icon='add user'
                                iconPosition='left'
                                placeholder='phoneBalance'
                                // onFocus={props.amp_logFieldClick}
                                onChange={this.handleTextInputChange}
                                type='number' />
                        </Form.Field>
                        <Button color='blue' fluid size='large'>SEND</Button>
                    </Form>
                    <h4>TRANSACTIONS</h4>
                    {cardList}

                </Segment>


            </div>
            : <h2>YOU ARE NOT AN AUTHORIZED</h2>


        return (
            this.state.loading ? <UiConsts.LoadingComponent /> :
                <div>
                    <h1>Phone Logs</h1>
                    {wholeUI}
                </div>
        );
    }
}

export default PhoneMoneyLog;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/PhoneMoneyLog/PhoneMoneyLog.js